import React from 'react';
import PropTypes from 'prop-types';
import { Wizard } from '../../../Modules';
import update from 'immutability-helper';
import djContract from './DJContract';

import PaymentMethods from './PaymentMethods';
import Fees from './Fees';
import LateFees from './LateFees';
import Travel from './Travel';
import Client from './Client';
import Venue from './Venue';
import Postponement from './Postponement';
import Cancellation from './Cancellation';
import Geo from './Geo';

const initialTerms = {
  postponementBeforeDays: 90,
  postponementAfterDays: 60,
  paymentGracePeriod: 7,
  paymentDaysBefore: 14,
  interest: 2,
  travelRadius: 30,
  travelOrigin: '',
  overtimeRate: 100,
  overtimeCurrency: 'USD',
  planningDeadline: 2,
  planningDeadlineUnits: 'weeks',
  postponementPenalty: 25,
  cancellationBeforeDays: 60,
  cancellationPenalty: 50,
  lateCancellationPenalty: 100,
  state: '',
  county: '',
  paymentMethods: ['cash', 'check', 'credit card'],
  mealRequired: false,
  outdoorSurcharge: true,
  setupInstructionsRequired: false,
  setupInstructions:
    'Client will ensure DJ has adequate space for equipment and furnishings, and in any event, no less than a 6 x 6’ area with a 6’ table with skirting and linen. In addition, DJ table must be near or adjacent to the dance floor as well as be located within fifty (50) feet of at least (2) dedicated 20-amp circuits.'
};

export default class ContractBuilder extends React.Component {
  static propTypes = {
    save: PropTypes.func.isRequired,
    trigger: PropTypes.node.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      contractVariables: initialTerms
    };
    this.openModal = this.openModal.bind(this);
    this.checkboxChange = this.checkboxChange.bind(this);
    this.stateFieldChange = this.stateFieldChange.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.yesNoChange = this.yesNoChange.bind(this);
    this.save = this.save.bind(this);
  }

  openModal() {
    this.setState({ contractVariables: initialTerms });
  }

  checkboxChange(e, { checked, name, value }) {
    if (checked) {
      this.setState(
        update(this.state, {
          contractVariables: {
            [name]: { $push: [value] }
          }
        })
      );
    } else {
      this.setState(
        update(this.state, {
          contractVariables: {
            [name]: {
              $splice: [[this.state.contractVariables[name].indexOf(value), 1]]
            }
          }
        })
      );
    }
  }

  textFieldChange(e) {
    this.setState(
      update(this.state, {
        contractVariables: {
          [e.target.name]: { $set: e.target.value }
        }
      })
    );
  }

  stateFieldChange(e) {
    this.setState(
      update(this.state, {
        contractVariables: {
          state: { $set: e.target.value }
        }
      })
    );
  }

  yesNoChange(e, { name, value }) {
    this.setState(
      update(this.state, {
        contractVariables: {
          [name]: { $set: value === 'yes' }
        }
      })
    );
  }

  save(model, resetForm, invalidateForm, successCb) {
    this.props.save(djContract(this.state.contractVariables), successCb);
  }

  render() {
    const { contractVariables } = this.state;
    return (
      <Wizard
        closeOnDimmerClick={false}
        steps={[
          {
            component: PaymentMethods,
            componentProps: {
              checkboxChange: this.checkboxChange,
              contractVariables,
              textFieldChange: this.textFieldChange
            },
            title: 'Payment Methods'
          },
          {
            component: Fees,
            componentProps: {
              yesNoChange: this.yesNoChange,
              textFieldChange: this.textFieldChange,
              contractVariables
            },
            title: 'Overtime and Additional Fees'
          },
          {
            component: LateFees,
            componentProps: {
              textFieldChange: this.textFieldChange,
              contractVariables
            },
            title: 'Late Fees'
          },
          {
            component: Travel,
            componentProps: {
              textFieldChange: this.textFieldChange,
              contractVariables
            },
            title: 'Travel Fees'
          },
          {
            component: Client,
            componentProps: {
              textFieldChange: this.textFieldChange,
              contractVariables,
              yesNoChange: this.yesNoChange
            },
            title: 'Client Responsibilities'
          },
          {
            component: Venue,
            componentProps: {
              textFieldChange: this.textFieldChange,
              contractVariables,
              yesNoChange: this.yesNoChange
            },
            title: 'Venue Requirements'
          },
          {
            component: Postponement,
            componentProps: {
              textFieldChange: this.textFieldChange,
              contractVariables
            },
            title: 'Postponement'
          },
          {
            component: Cancellation,
            componentProps: {
              textFieldChange: this.textFieldChange,
              contractVariables
            },
            title: 'Cancellation'
          },
          {
            component: Geo,
            componentProps: {
              textFieldChange: this.textFieldChange,
              stateFieldChange: this.stateFieldChange,
              contractVariables
            },
            title: 'Your Location',
            actions: { primary: { type: 'submit' } },
            formProps: { onValidSubmit: this.save, onInvalidSubmit: this.save }
          }
        ]}
        trigger={this.props.trigger}
        onOpen={this.openModal}
        showProgress
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/TermsBuilder.js